"use client";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
export default function Navbar() {

  const pathname = usePathname();
  return (
    <div
      className="w-full flex  px-5 lg:px-20 md:px-10 py-5 bg-cover bg-center text-base border"
      style={{ backgroundImage: "url('/hero_section/navbar_bg.svg')" }}
    >
      <Link href="/" className="flex items-center space-x-4 justify-start cursor-pointer" title="Go to homepage">
        <Image src="/application_logo/second_line_logo.svg" width={40} height={40} alt="app-logo" />
        <span className="text-[24px] font-bold text-nowrap hidden lg:block md:block">
          2nd Line
        </span>
      </Link>
      <div className="w-full flex justify-between items-baseline">
        <div className="flex justify-center w-full px-3 mt-2 lg:mt-0 space-x-3 lg:space-x-6 md:space-x-4 items-center">
          <Link
            className={`cursor-pointer text-gray-700 text-sm hover:text-[#1CBFA2] lg:text-[16px] ${
              pathname === "/"
                ? "underline underline-offset-4 decoration-1 text-[#1CBFA2] "
                : ""
            }`}
            href="/"
            title="Go to homepage"
          >
            Home
          </Link>
          <span className="border-l-2 border-gray-300 h-5"></span>
          <Link
            className={`cursor-pointer text-gray-700 text-sm hover:text-[#1CBFA2]  lg:text-[16px]  ${
              pathname === "/support"
                ? "underline underline-offset-4 decoration-1 text-[#1CBFA2]"
                : ""
            }`}
            href="/support"
            title="Go to Support Page"
          >
            Support
          </Link>
        </div>

        <div className="flex items-baseline ">
           <a
            className="text-white py-3 px-5 bg-[#1CBFA2] text-nowrap hover:bg-[#14A498] rounded-full text-sm lg:text-[18px] w-auto lg:w-[180px] font-medium flex justify-center"
            href="https://apps.apple.com/us/app/second-phone-number-2nd-line/id1607181162"
            target="_blank"
            rel="noopener noreferrer"
          >
            Get the App
          </a>
        </div>
      </div>
    </div>
  );
}
